import React, {createContext, Dispatch, SetStateAction, useContext, useState, useEffect} from 'react';
import {IPlatforms} from '../../types/offers';
import {getOS} from '../../helpers';

interface IFilterContext {
  filterType: IPlatforms;
  setFilterType: Dispatch<SetStateAction<IPlatforms>>;
  isFilterOpen: boolean;
  setIsFilterOpen: Dispatch<SetStateAction<boolean>>;
}

const getInitialState = (): IPlatforms => {
  const userOS = getOS();
  return {
    android: userOS === 'Android' || userOS === 'Other',
    ios: userOS === 'iOS' || userOS === 'Other',
    // @ts-ignore
    desktop: userOS === 'Desktop' || userOS === 'Other'
  };
};

//create context to save device type filters value

const FilterContext = createContext<IFilterContext>({
  filterType: getInitialState(),
  setFilterType: () => {},
  isFilterOpen: false,
  setIsFilterOpen: () => {}
});

export const FilterContextProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [filterType, setFilterType] = useState<IPlatforms>(getInitialState());
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);

  return <FilterContext.Provider value={{filterType, setFilterType, isFilterOpen, setIsFilterOpen}}>{children}</FilterContext.Provider>;
};

//hook to get/set device type filters value

export const useFilterContext = () => {
  const context = useContext(FilterContext);

  if (!context) {
    throw new Error('useFilterContext must be used within useContextProvider');
  }

  return context;
};
